module.exports = __webpack_public_path__ + "static/media/bytt-no-11.fb8b3c74.mp3";